export default "__VITE_ASSET__C5fcy8rI__"